import { companyInfo } from '@/mocks/homeContent';

export default function CompanySection() {
  return (
    <section id="company" className="w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            COMPANY
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            会社概要
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-10 items-start">
          {/* Info table */}
          <div className="rounded-lg bg-background-50 border border-background-200 overflow-hidden">
            <table className="w-full text-sm md:text-base">
              <tbody>
                {companyInfo.map((info, idx) => (
                  <tr
                    key={info.label}
                    className={`border-b border-background-200 ${
                      idx === companyInfo.length - 1 ? 'last:border-b-0' : ''
                    }`}
                  >
                    <th className="w-32 md:w-40 px-5 md:px-6 py-4 bg-secondary-100 text-secondary-900 text-left font-bold align-top">
                      {info.label}
                    </th>
                    <td className="px-5 md:px-6 py-4 text-foreground-800 leading-relaxed">
                      {info.value}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Map */}
          <div className="rounded-lg overflow-hidden border border-background-200 bg-background-50">
            <div className="aspect-[4/3] w-full">
              <iframe
                title="吉川産業 京都本社アクセスマップ"
                src="https://www.google.com/maps?q=%E4%BA%AC%E9%83%BD%E5%BA%9C%E4%BA%AC%E9%83%BD%E5%B8%82%E5%B7%A6%E4%BA%AC%E5%8C%BA%E7%94%B0%E4%B8%AD%E4%B8%8A%E7%8E%84%E4%BA%AC%E7%94%BA53-1&t=m&z=16&output=embed"
                loading="lazy"
                className="w-full h-full border-0"
              />
            </div>
            <div className="p-5 md:p-6">
              <div className="flex items-center gap-2 text-foreground-700 text-sm mb-3">
                <span className="w-4 h-4 flex items-center justify-center text-primary-600">
                  <i className="ri-map-pin-line" />
                </span>
                <span>京都府京都市左京区田中上玄京町53-1</span>
              </div>
              <div className="grid grid-cols-2 gap-3 text-xs md:text-sm">
                <div className="flex items-center gap-2 text-foreground-700">
                  <span className="w-4 h-4 flex items-center justify-center text-accent-700">
                    <i className="ri-time-line" />
                  </span>
                  <span>9:00〜17:00</span>
                </div>
                <div className="flex items-center gap-2 text-foreground-700">
                  <span className="w-4 h-4 flex items-center justify-center text-accent-700">
                    <i className="ri-calendar-line" />
                  </span>
                  <span>年中無休</span>
                </div>
                <div className="flex items-center gap-2 text-foreground-700">
                  <span className="w-4 h-4 flex items-center justify-center text-accent-700">
                    <i className="ri-truck-line" />
                  </span>
                  <span>京都府全域対応</span>
                </div>
                <div className="flex items-center gap-2 text-foreground-700">
                  <span className="w-4 h-4 flex items-center justify-center text-accent-700">
                    <i className="ri-shield-check-line" />
                  </span>
                  <span>各種許可番号取得済</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}